import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * EV User Retrieval API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.44
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";
import { DocSearchResponse } from "../modelrest/DocSearchResponse";
import { FullTextResults } from "../modelrest/FullTextResults";

/**
 * EvSearch service.
 * @module api/EvSearchApi
 * @version 1.0
 */
export var EvSearchApi = /*#__PURE__*/function () {
  /**
    * Constructs a new EvSearchApi. 
    * @alias module:api/EvSearchApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
  function EvSearchApi(apiClient) {
    _classCallCheck(this, EvSearchApi);
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * @param {module:modelrest/SearchesEntityBean} body
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:modelrest/FullTextResults} and HTTP response
   */
  _createClass(EvSearchApi, [{
    key: "getResultsWithHttpInfo",
    value: function getResultsWithHttpInfo(body) {
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling getResults");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = FullTextResults;
      return this.apiClient.callApi("/rest/search/results", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:modelrest/FullTextResults}
     */
  }, {
    key: "getResults",
    value: function getResults(body) {
      return this.getResultsWithHttpInfo(body).then(function (response) {
        return response.data;
      });
    }

    /**
     * old search call
     * @param {module:modelrest/SearchInputCore} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getResultsClassicWithHttpInfo",
    value: function getResultsClassicWithHttpInfo(body) {
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling getResultsClassic");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/search/results/classic", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * old search call
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getResultsClassic",
    value: function getResultsClassic(body) {
      return this.getResultsClassicWithHttpInfo(body).then(function (response) {
        return response.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:modelrest/String} opts.searchtype
     * @param {String} opts.searchWord1
     * @param {String} opts.section1
     * @param {String} opts.autostem
     * @param {String} opts.sort
     * @param {String} opts.sortdir
     * @param {Number} opts.pageSize
     * @param {Number} opts.offset
     * @param {String} opts.databasemask
     * @param {String} opts.startYear
     * @param {String} opts.endYear
     * @param {String} opts.updatesNo
     * @param {String} opts.emailalertweek
     * @param {Boolean} opts.highlightingEnabled
     * @param {Boolean} opts.fetchNavigator
     * @param {Number} opts.navDataCount
     * @param {String} opts.language
     * @param {String} opts.documenttype
     * @param {String} opts.disciplinetype
     * @param {String} opts.treatmentType
     * @param {module:modelrest/String} opts.boolean1
     * @param {String} opts.searchWord2
     * @param {String} opts.section2
     * @param {String} opts.boolean2
     * @param {String} opts.searchWord3
     * @param {String} opts.section3
     * @param {String} opts.booleansStr
     * @param {String} opts.searchphrases
     * @param {String} opts.sectionStr
     * @param {Boolean} opts.legacyRedirectUrl return legacy URL (default to <.>)
     * @param {Boolean} opts.results return results (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:modelrest/DocSearchResponse} and HTTP response
     */
  }, {
    key: "submitSearchWithHttpInfo",
    value: function submitSearchWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        legacyRedirectUrl: opts.legacyRedirectUrl,
        results: opts.results
      };
      var headerParams = {};
      var formParams = _objectSpread({
        searchtype: opts.searchtype,
        searchWord1: opts.searchWord1,
        section1: opts.section1,
        autostem: opts.autostem,
        sort: opts.sort,
        sortdir: opts.sortdir,
        pageSize: opts.pageSize,
        offset: opts.offset,
        databasemask: opts.databasemask,
        startYear: opts.startYear,
        endYear: opts.endYear,
        updatesNo: opts.updatesNo,
        emailalertweek: opts.emailalertweek,
        highlightingEnabled: opts.highlightingEnabled,
        fetchNavigator: opts.fetchNavigator,
        navDataCount: opts.navDataCount,
        language: opts.language,
        documenttype: opts.documenttype,
        disciplinetype: opts.disciplinetype,
        treatmentType: opts.treatmentType,
        boolean1: opts.boolean1,
        searchWord2: opts.searchWord2,
        section2: opts.section2,
        boolean2: opts.boolean2,
        searchWord3: opts.searchWord3,
        section3: opts.section3,
        booleansStr: opts.booleansStr,
        searchphrases: opts.searchphrases,
        sectionStr: opts.sectionStr
      }, opts);
      var authNames = ["usersession"];
      var contentTypes = ["application/x-www-form-urlencoded"];
      var accepts = ["application/json"];
      var returnType = DocSearchResponse;
      return this.apiClient.callApi("/rest/search/submit", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:modelrest/String} opts.searchtype
     * @param {String} opts.searchWord1
     * @param {String} opts.section1
     * @param {String} opts.autostem
     * @param {String} opts.sort
     * @param {String} opts.sortdir
     * @param {Number} opts.pageSize
     * @param {Number} opts.offset
     * @param {String} opts.databasemask
     * @param {String} opts.startYear
     * @param {String} opts.endYear
     * @param {String} opts.updatesNo
     * @param {String} opts.emailalertweek
     * @param {Boolean} opts.highlightingEnabled
     * @param {Boolean} opts.fetchNavigator
     * @param {Number} opts.navDataCount
     * @param {String} opts.language
     * @param {String} opts.documenttype
     * @param {String} opts.disciplinetype
     * @param {String} opts.treatmentType
     * @param {module:modelrest/String} opts.boolean1
     * @param {String} opts.searchWord2
     * @param {String} opts.section2
     * @param {String} opts.boolean2
     * @param {String} opts.searchWord3
     * @param {String} opts.section3
     * @param {String} opts.booleansStr
     * @param {String} opts.searchphrases
     * @param {String} opts.sectionStr
     * @param {Boolean} opts.legacyRedirectUrl return legacy URL (default to <.>)
     * @param {Boolean} opts.results return results (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:modelrest/DocSearchResponse}
     */
  }, {
    key: "submitSearch",
    value: function submitSearch(opts) {
      return this.submitSearchWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }

    /**
     * @param {module:modelrest/SearchInputForm} body
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.legacyRedirectUrl  (default to <.>)
     * @param {Boolean} opts.results  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:modelrest/DocSearchResponse} and HTTP response
     */
  }, {
    key: "submitSearchJsonWithHttpInfo",
    value: function submitSearchJsonWithHttpInfo(body, opts) {
      opts = opts || {};
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling submitSearchJson");
      }
      var pathParams = {};
      var queryParams = {
        legacyRedirectUrl: opts.legacyRedirectUrl,
        results: opts.results
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = DocSearchResponse;
      return this.apiClient.callApi("/rest/search/submit/json", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.legacyRedirectUrl  (default to <.>)
     * @param {Boolean} opts.results  (default to <.>)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:modelrest/DocSearchResponse}
     */
  }, {
    key: "submitSearchJson",
    value: function submitSearchJson(body, opts) {
      return this.submitSearchJsonWithHttpInfo(body, opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return EvSearchApi;
}();